export const ACCOUNT_ACTIONS = {
  PROFILE: 'profile',
  ORDERS: 'orders',
  REVIEWS: 'reviews',
  ADDRESSES: 'addresses',
  INVITATIONS: 'invitations',
  PAYMENT_METHODS: 'payment-methods',
  DETAILS: 'details',
  OFFERS: 'offers',
  NOTIFICATIONS: 'notifications',
  SMS: 'sms',
  LOYALTY_LISTS: 'loyalty-lists',
  MILES_AND_MORE: 'miles-and-more'
}

export const ACCOUNT_NAV_ITEMS = [
  {
    action: ACCOUNT_ACTIONS.PROFILE,
    labelKey: 'account_nav_profile',
    descriptionKey: 'account_nav_profile_desc'
  },
  {
    action: ACCOUNT_ACTIONS.ORDERS,
    labelKey: 'account_nav_orders',
    descriptionKey: 'account_nav_orders_desc'
  },
  {
    action: ACCOUNT_ACTIONS.REVIEWS,
    labelKey: 'account_nav_reviews',
    descriptionKey: 'account_nav_reviews_desc'
  },
  {
    action: ACCOUNT_ACTIONS.ADDRESSES,
    labelKey: 'account_nav_addresses',
    descriptionKey: 'account_nav_addresses_desc'
  },
  {
    action: ACCOUNT_ACTIONS.INVITATIONS,
    labelKey: 'account_nav_invitations',
    descriptionKey: 'account_nav_invitations_desc'
  },
  {
    action: ACCOUNT_ACTIONS.PAYMENT_METHODS,
    labelKey: 'account_nav_payment_methods',
    descriptionKey: 'account_nav_payment_methods_desc'
  },
  {
    action: ACCOUNT_ACTIONS.DETAILS,
    labelKey: 'account_nav_details',
    descriptionKey: 'account_nav_details_desc'
  },
  {
    action: ACCOUNT_ACTIONS.OFFERS,
    labelKey: 'account_nav_offers',
    descriptionKey: 'account_nav_offers_desc'
  },
  {
    action: ACCOUNT_ACTIONS.NOTIFICATIONS,
    labelKey: 'account_nav_notifications',
    descriptionKey: 'account_nav_notifications_desc'
  },
  {
    action: ACCOUNT_ACTIONS.SMS,
    labelKey: 'account_nav_sms',
    descriptionKey: 'account_nav_sms_desc'
  },
  {
    action: ACCOUNT_ACTIONS.LOYALTY_LISTS,
    labelKey: 'account_nav_loyalty_lists',
    descriptionKey: 'account_nav_loyalty_lists_desc'
  },
  {
    action: ACCOUNT_ACTIONS.MILES_AND_MORE,
    labelKey: 'account_nav_miles_and_more',
    descriptionKey: 'account_nav_miles_and_more_desc'
  }
]

/**
 * Map of account action -> component key.
 * Used for dynamic content; actual components are resolved in TheAccountTemplate.
 * Replace placeholder keys with specific component keys when implementing sections.
 */
export const ACCOUNT_ACTION_COMPONENT_KEYS = {
  [ACCOUNT_ACTIONS.PROFILE]: 'placeholder',
  [ACCOUNT_ACTIONS.ORDERS]: 'placeholder',
  [ACCOUNT_ACTIONS.REVIEWS]: 'placeholder',
  [ACCOUNT_ACTIONS.ADDRESSES]: 'placeholder',
  [ACCOUNT_ACTIONS.INVITATIONS]: 'placeholder',
  [ACCOUNT_ACTIONS.PAYMENT_METHODS]: 'placeholder',
  [ACCOUNT_ACTIONS.DETAILS]: 'placeholder',
  [ACCOUNT_ACTIONS.OFFERS]: 'placeholder',
  [ACCOUNT_ACTIONS.NOTIFICATIONS]: 'placeholder',
  [ACCOUNT_ACTIONS.SMS]: 'placeholder',
  [ACCOUNT_ACTIONS.LOYALTY_LISTS]: 'placeholder',
  [ACCOUNT_ACTIONS.MILES_AND_MORE]: 'placeholder'
}
